import Select from "react-select"

export default function DespesasMetricasFiltroOptions({ options, value, id_form, label, onChange }: iProps) { 
    return (
        <div>
            <Select name={id_form} id={id_form} options={options} placeholder={label} value={value} isMulti closeMenuOnSelect={false} onChange={
                (choice) => {
                    onChange(choice, id_form)
                }
            } styles={customSelectStyles} />
        </div>
    )
}
interface iProps { 
    options: any[]
    value: any[]
    id_form: string
    label: string
    onChange: any
}

const customSelectStyles = {
    control: (baseStyles:any, state:any) => ({
        ...baseStyles,
        width: '256px',
        borderColor: "#dee2e6",
        minHeight: '40px',
        maxHeight: '120px',
        marginRight: '5px'
    }),
    valueContainer: (provided:any, state:any) => ({
        ...provided,
        minHeight: '30px',
        maxHeight: '120px',
        overflowY: 'auto',
    }),
    input: (provided:any, state:any) => ({
        ...provided,
        margin: '0px',
    }),
    indicatorSeparator: (state:any) => ({
        display: 'none',
        minHeight: '40px',
        maxHeight: '120px',
    }),
    indicatorsContainer: (provided:any, state:any) => ({
        ...provided,
        height: '40px',
    }),
}
